import { Box, Header, Text } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { TableHeader } from 'components/nutrition/v2/table-header';
import Picture from 'components/picture';
import { IIngredients } from 'generated/sanity-graphql';
import { useFeatureMenu } from 'hooks/use-feature-menu';
import { ILocalizedMenuEntry } from 'state/unified-menu/types';
import { getKeysWithoutTypename, mapImageResourceToSanityImage } from 'state/unified-menu/utils';
import { getUnitForNutrient } from 'utils/menu';

import { ItemAllergens } from './item-allergens';
import { ItemIngredients } from './item-ingredients-information';
import { NutrientText } from './styled';

type ItemNutritionInformationProps = {
  item: ILocalizedMenuEntry;
};

export const ItemNutritionInformation = ({ item }: ItemNutritionInformationProps) => {
  const { formatMessage, formatNumber } = useIntl();
  const { featureMenu } = useFeatureMenu();

  const findIngredients = (itemId: string) => {
    const callback = (item: any) => item._id === itemId;
    let ingredients = featureMenu?.upsellItemsAtCheckoutDelivery?.find(callback)?.ingredients;

    if (!ingredients?.length) {
      ingredients = featureMenu?.upsellItemsAtCheckoutRestaurant?.find(callback)?.ingredients;
    }

    return (ingredients || []) as IIngredients[];
  };

  const nutritionLabels = getKeysWithoutTypename(item.nutrition?.nutrients || {}).filter(
    label => !!item.nutrition?.nutrients?.[label]
  );

  return (
    <Box>
      <Picture
        image={mapImageResourceToSanityImage(item.image?.resource ?? '')}
        alt="itemImage"
        objectFitContain
        width={300}
        height={300}
        alignSelf="center"
      />
      <Box marginBottom="$4">
        <Header textAlign="center" focusable>
          {item.name?.locale}
        </Header>
        <TableHeader testID="per-serving-header" title={formatMessage({ id: 'perServing' })} />
        {nutritionLabels.map(label => (
          <NutrientText key={label}>
            <Text textTransform="capitalize">{formatMessage({ id: 'us-' + label })}</Text>
            <Text>
              {`${formatNumber(item.nutrition!.nutrients![label]!, {
                maximumFractionDigits: 1,
              })} ${getUnitForNutrient(label)}`}
            </Text>
          </NutrientText>
        ))}
        <ItemIngredients ingredients={findIngredients(item.id)} />
        {item.nutrition?.allergens && <ItemAllergens item={item} />}
      </Box>
    </Box>
  );
};
